import React from 'react';

import cl from 'classnames';

import Text from 'components/shared/Typography/Text';

import EventPlank from './EventPlank';
import s from './index.module.css';
import * as types from './types';

function DaySlot({ slot, calendarDay, period }: types.DaySlotProps) {
  if (slot.type === 'event') {
    const event = slot.data;
    return <EventPlank calendarDay={calendarDay} event={event} period={period} />;
  }

  return (
    <div className={cl(s.slot, s['slot-hidden'])}>
      <Text className={s['slot-text']} size="medium">
        Empty
      </Text>
    </div>
  );
}

export default DaySlot;
